import * as z from 'zod';
/** En reservation som behöver samma lagerartikel strax efter att en annan slutar, så den måste lämnas tillbaka i tid. */
export const FollowingReservation = z.object({
    reservation_item_id: z.number(),
    reservation_number: z.string().nullable(),
    reservable_identifier: z.string(),
    delivery_date_time: z.string()
});
